import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6aa840e30a1ed800140538b9_1789422700198_4d845385/msbeautycare/src/app/not-found.tsx");
